import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaSpinner, FaUser, FaHeart, FaPlay, FaArrowRight, FaArrowLeft, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Historique_simulation = ({ titre }) => {
    useAuth();
    const existingAcces = { acces: [] }; // Ensure this is defined

    const [simulations, setSimulations] = useState([]);
    const [selectedSimulation, setSelectedSimulation] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [domainesFr, setDomainesFr] = useState([]); // Pour stocker les domaines
    const [groupeProcessusFr, setGroupeProcessusFr] = useState([]); // Pour stocker les domaines
    const [flashingIds, setFlashingIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingLancement, setIsLoadingLancement] = useState(false);
    const [isLoadingEnreg, setIsLoadingEnreg] = useState(false);
    const [showInfo, setShowInfo] = useState(false);


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = simulations.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Simulateur"; // Définit le titre de la page
        }
    }, [user_id]);

    const fetchSimulations = async () => {
    setIsLoading(true);
    try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/liste-simulation/${user_id}/`);
        if (response.ok) {
            const data = await response.json();
            // NE TRIEZ PAS ICI - laissez les données dans l'ordre original
            setSimulations(data);
            setIsLoading(false);
        } else {
            console.error('Erreur lors de la récupération des simulations');
        }
    } catch (error) {
        console.error('Erreur réseau:', error);
    }
};

    useEffect(() => {

        fetchSimulations();
    }, []);



    useEffect(() => {
        const fetchDomaines = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + '/Liste-domaine/');
                if (response.ok) {
                    const data = await response.json();
                    setDomainesFr(data);
                } else {
                    console.error('Erreur lors de la récupération des domaines');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchDomaines();
    }, []);

    useEffect(() => {
        const fetchGroupeProcessus = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + '/listes-groupes-processus/');
                if (response.ok) {
                    const data = await response.json();
                    setGroupeProcessusFr(data);
                } else {
                    console.error('Erreur lors de la récupération des groupes processus');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };
        fetchGroupeProcessus();
    }, []);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        fetchSimulations()
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        fetchSimulations();
    };


    const handleRowClick = (simulation) => {
        setSelectedSimulation(simulation);
    };


    const filteredSimulations = simulations.filter(simulation =>
        (simulation.date && simulation.date.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (simulation.domaine_titre && simulation.domaine_titre.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (simulation.processus_titre && simulation.processus_titre.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (simulation.qcmNumber && simulation.qcmNumber.toString().includes(searchTerm)) ||  // Pas de toLowerCase car c'est un nombre
        (simulation.tags && simulation.tags.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (simulation.niveau && simulation.niveau.toString().includes(searchTerm)) ||  // Pas de toLowerCase car c'est un nombre
        (simulation.langue && simulation.langue.toLowerCase().includes(searchTerm)) ||
        (simulation.pourcentage && simulation.pourcentage.toString().includes(searchTerm)) // Pas de toLowerCase car c'est un pourcentage
    );


    const sortedSimulations = [...filteredSimulations].sort((a, b) => {
        if (sortConfig.key === 'date') {
            // Comparaison des dates : de manière croissante ou décroissante
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            if (sortConfig.direction === 'ascending') {
                return dateA - dateB; // Tri croissant
            } else {
                return dateB - dateA; // Tri décroissant
            }
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastSimulation = currentPage * itemsPerPage;
    const indexOfFirstSimulation = indexOfLastSimulation - itemsPerPage;
    const currentSimulations = sortedSimulations.slice(indexOfFirstSimulation, indexOfLastSimulation);
    const totalPages = Math.ceil(sortedSimulations.length / itemsPerPage);

    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser à la première page
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setAlertModal({ message: '', type: '' });
    }
    const handleShowModal = () => {
        setShowModal(true)
    }; // Function to open the modal

    const [newSimulation, setNewSimulation] = useState({
        domaine: '',
        processus: '',
        langue: '',
        niveau: '',
        qcmNumber: '',
        agile: false,
        nonTraite: false,
    });

    const handleNewSimulationChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewSimulation((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };


    const handleSubmitNewSimulation = async () => {
        // Vérifications pour s'assurer que les champs ne sont pas vides
        setIsLoadingEnreg(true)
        if (
            !newSimulation.domaine ||
            !newSimulation.langue ||
            !newSimulation.processus ||
            !newSimulation.niveau ||
            !newSimulation.qcmNumber
        ) {
            showAlertModal("Veuillez remplir tous les champs obligatoires.", "danger");
            return; // Empêche la soumission si des champs sont vides
        }
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enreg-simulation/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newSimulation),
            });

            const data = await response.json();

            if (response.ok) {
                console.log('Réponse du serveur :', data);

                setShowModal(false); // Fermer le modal après soumission
                showAlert("Simulation enregistrée avec succès !");
                setNewSimulation({
                    domaine: '',
                    processus: '',
                    langue: '',
                    niveau: '',
                    qcmNumber: '',
                    agile: false,
                    nonTraite: false,
                });
            } else {
                showAlertModal(data.error, 'danger')
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlertModal("Une erreur est survenue lors de l\'enregistrement !", "danger");
        } finally{
            setIsLoadingEnreg(false)
        }
    };



    const handleDemarrer = async () => {
        setIsLoadingLancement(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/demarrer-simulation/${user_id}/${selectedSimulation.id}/`);
            if (response.ok) {
                navigate(`/Demarrer`, {
                    state: { simulation_id: selectedSimulation },
                });
            } else {
                const data = response.KeyError;
                console.error('Erreur lors du démarrage');
                showAlert('Cette simulation ne respecte pas les conditions recquises.', 'danger')
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingLancement(false)
        }
    };

    const [previousIds, setPreviousIds] = useState([]);
    const [isInitialRender, setIsInitialRender] = useState(true);

    const areArraysEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) return false; // Longueurs différentes
        return arr1.every((id, index) => id === arr2[index]); // Compare chaque élément
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Simulation")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><BsStopwatch size={25} className='mr-2' />Simulateur
                            </h2>
                            <small>Plus de 2.500 questions à choix multiples pour vous préparer à affronter l'examen final. Courage!</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/simulateur`}> Simulateur </Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                        <div className="col-lg-12">
                        </div>
                    </div>
                    {/* <Header titre="Simulations" sous_titre="Dashboard" sous_titre1={<Link to={`/admin`} className='text-dark'>Administration</Link>} entete="Simulations"  user_id={user_id}/> */}
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Historique des simulations</h5>
                                <div className="d-flex">
                                    <Link to={`/Favoris`} className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1">
                                        <FaHeart />
                                        <span className="d-none d-sm-inline ml-2">
                                            Favoris
                                        </span>
                                    </Link>
                                    <button
                                        onClick={() => handleDemarrer(selectedSimulation)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedSimulation ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedSimulation} // Désactiver le bouton si aucune simulation n'est sélectionnée
                                    >
                                        <FaPlay />
                                        <span className="d-none d-sm-inline ml-2">
                                            {isLoadingLancement ? 'Chargement..' : 'Démarrer'}
                                        </span>
                                    </button>
                                    <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mt-1" onClick={handleShowModal}>
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Nouvelle simulation
                                        </span>
                                    </button>

                                </div>
                            </div>
                            <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header >
                                    <Modal.Title>Nouvelle simulation</Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-2 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    <Form>
                                        {/* Domaine de connaissance */}
                                        <Form.Group controlId="formDomaine">
                                            <Form.Label>Domaine de connaissance</Form.Label>
                                            <Form.Control as="select" name="domaine" value={newSimulation.domaine} onChange={handleNewSimulationChange} required>
                                                <option value="">Sélectionnez le domaine</option>
                                                {domainesFr.map((domaine) => (
                                                    <option key={domaine.id} value={domaine.ordre}>
                                                        {domaine.titre}
                                                    </option>
                                                ))}
                                                <option value="0">Tout</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Groupe de processus */}
                                        <Form.Group controlId="formProcessus" className="mt-3">
                                            <Form.Label>Groupe de processus</Form.Label>
                                            <Form.Control as="select" name="processus" value={newSimulation.processus} onChange={handleNewSimulationChange} required>
                                                <option value="">Sélectionnez le groupe</option>
                                                {groupeProcessusFr.map((groupe_processus) => (
                                                    <option key={groupe_processus.id} value={groupe_processus.ordre}>
                                                        {groupe_processus.titre_fr}
                                                    </option>
                                                ))}
                                                <option value="0">Tout</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Niveau de difficulté */}
                                        <Form.Group controlId="formNiveau" className="mt-3">
                                            <Form.Label>Niveau de difficulté</Form.Label>
                                            <Form.Control as="select" name="niveau" value={newSimulation.niveau} onChange={handleNewSimulationChange} required>
                                                <option value="">Sélectionnez le niveau</option>
                                                <option value="1">Niveau 1</option>
                                                <option value="2">Niveau 2</option>
                                                <option value="0">Tout</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Nombre de QCM à simuler */}
                                        <Form.Group controlId="formNombreQCM" className="mt-3">
                                            <Form.Label>Nombre de QCM à simuler</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                name="qcmNumber"
                                                value={newSimulation.qcmNumber}
                                                onChange={handleNewSimulationChange}
                                                placeholder="Entrer le nombre de QCM"
                                                required
                                            />
                                        </Form.Group>


                                        <Form.Group controlId="formNiveau" className="mt-3">
                                            <Form.Label>Langue</Form.Label>
                                            <Form.Control as="select" name="langue" value={newSimulation.langue} onChange={handleNewSimulationChange} required>
                                                <option value="">Sélectionnez la langue</option>
                                                <option value="Fr">Francais</option>
                                                <option value="Ang">Anglais</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Case à cocher : Adaptation/Agile */}
                                        {/* <Form.Group controlId="formAgile" className="mt-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Afficher seulement les QCM sur Adaptation/Agile"
                                                name="agile"
                                                checked={newSimulation.agile}
                                                onChange={handleNewSimulationChange}
                                                required
                                            />
                                        </Form.Group> */}

                                        {/* Case à cocher : QCM non traités */}
                                        <Form.Group controlId="formNonTraite" className="mt-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Afficher seulement les QCM non traités"
                                                name="nonTraite"
                                                checked={newSimulation.nonTraite}
                                                onChange={handleNewSimulationChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="default" onClick={handleCloseModal}>
                                        Fermer
                                    </Button>
                                    <Button variant="success" onClick={handleSubmitNewSimulation}>

                                        {isLoadingEnreg ? 'Chargement..' : 'Enregistrer'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12 pr-0 pl-0">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            {/* Date */}
                                                            <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('date')}>
                                                                Date
                                                                {sortConfig.key === 'date'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* Domaine */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('domaine_titre')}>
                                                                Domaine de connaissance
                                                                {sortConfig.key === 'domaine_titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* Groupe de processus */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('processus_titre')}>
                                                                Groupe de processus
                                                                {sortConfig.key === 'processus_titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* Nbre de questions (visible sur md et plus) */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('qcmNumber')}>
                                                                Nbre de questions
                                                                {sortConfig.key === 'qcmNumber'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* langue (visible sur md et plus) */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('langue')}>
                                                                Langue
                                                                {sortConfig.key === 'langue'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* Niveau */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('niveau')}>
                                                                Niveau
                                                                {sortConfig.key === 'niveau'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* Réussite (visible sur md et plus) */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('reussite')}>
                                                                Réussite
                                                                {sortConfig.key === 'reussite'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>

                                                            {/* Réussite (visible sur md et plus) */}
                                                            <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('tags')}>
                                                                Tags
                                                                {sortConfig.key === 'tags'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoading ? (
                                                            currentSimulations.map((simulation) => (
                                                                <tr
                                                                    key={simulation.id}
                                                                    onClick={() => handleRowClick(simulation)}
                                                                    className={`bg-white ${selectedSimulation && selectedSimulation.id === simulation.id ? 'bg-success text-white' : ''
                                                                        } ${flashingIds.length === 1 && flashingIds.includes(simulation.id) ? 'flash' : ''}`}
                                                                >
                                                                    <td>
                                                                        {simulation.date}
                                                                        <div className='lesInfos'>
                                                                            <small>Domaine : {simulation.date}</small><br />
                                                                            <small>Processus : {simulation.domaine_titre}</small><br />
                                                                            <small>Nbre de questions : {simulation.qcmNumber}</small><br />
                                                                            <small>Langue : {simulation.langue}</small><br />
                                                                            <small>Niveau : {simulation.niveau}</small><br />
                                                                            <small>Tags : {simulation.tags}</small><br />
                                                                            <small>Pourcentage : {simulation.pourcentage ? simulation.pourcentage + "%" : "0%"}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.domaine_titre}</td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.processus_titre}</td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.qcmNumber}</td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.langue}</td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.niveau}</td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.pourcentage ? simulation.pourcentage + "%" : "0%"}</td>
                                                                    <td className="d-none text-center d-md-table-cell">{simulation.tags}</td>
                                                                </tr>

                                                            ))
                                                        ) : (
                                                            <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                <span
                                                                    className="spinner-border spinner-border-lg text-success"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    style={{ width: '3rem', height: '3rem' }}
                                                                ></span>
                                                            </div>

                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* <div className="dataTables_info" role="status" aria-live="polite">
                                                    {`Élément ${indexOfFirstSimulation + 1} à ${Math.min(indexOfLastSimulation, totalItems)} sur ${totalItems}`}
                                                </div> */}
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstSimulation + 1} à ${Math.min(indexOfLastSimulation, totalItems)} sur ${totalItems}`}
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Styles CSS pour les cellules fixes */}
            <style jsx>{`
    width: 300px; /* Ajustez cette valeur selon vos besoins */
    overflow: hidden; /* Évite le débordement de contenu */
    text-overflow: ellipsis; /* Ajoute des "..." pour le contenu tronqué si nécessaire */
    word-wrap: break-word; /* Permet au texte de s'enrouler et de casser les mots longs */
    overflow-wrap: break-word; /* Ajoute cette propriété pour la compatibilité */
    white-space: normal; /* Permet le retour à la ligne */
`}</style>
        </div>
    );
};

export default Historique_simulation;
